"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (props) {
    return _react2.default.createElement(
        "svg",
        { width: "24", height: "24", viewBox: "0 0 24 24", className: "Icon play-arrow", xmlns: "http://www.w3.org/2000/svg" },
        _react2.default.createElement("path", { d: "M24 12L0 24V0z", fill: "#FFF", fillRule: "evenodd" })
    );
}; /*eslint-disable */


//////////////////
// WEBPACK FOOTER
// ./src/client/components/icons/large/jsx/play-arrow.js
// module id = 1826
// module chunks = 0